import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import { Button } from '../components/Button';
export function ContactPage() {
  return <div className="w-full" data-id="element-211">
      {/* Hero */}
      <section className="py-20 bg-background px-6" data-id="element-212">
        <div className="max-w-7xl mx-auto text-center" data-id="element-213">
          <h1 className="text-5xl font-display font-bold text-charcoal mb-6" data-id="element-214">
            Contact Us
          </h1>
          <p className="text-xl text-muted max-w-2xl mx-auto" data-id="element-215">
            We're here to help you find the right housing solution. Reach out to
            us today.
          </p>
        </div>
      </section>

      <section className="py-20 px-6" data-id="element-216">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20" data-id="element-217">
          {/* Contact Info */}
          <div className="space-y-12" data-id="element-218">
            <div className="space-y-8" data-id="element-219">
              <h2 className="text-4xl font-display font-bold text-charcoal" data-id="element-220">
                Get in Touch
              </h2>
              <p className="text-lg text-muted leading-relaxed" data-id="element-221">
                Whether you have questions about our homes, need to schedule a
                tour, or want to discuss a referral, our team is ready to assist
                you.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-222">
              <div className="space-y-4" data-id="element-223">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-224">
                  <Phone size={24} data-id="element-225" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-226">Phone</h4>
                <p className="text-muted" data-id="element-227">(410) 555-0123</p>
                <p className="text-xs font-bold text-accent uppercase tracking-widest" data-id="element-228">
                  Available 24/7 for Emergencies
                </p>
              </div>
              <div className="space-y-4" data-id="element-229">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-230">
                  <Mail size={24} data-id="element-231" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-232">Email</h4>
                <p className="text-muted" data-id="element-233">info@birdsnestliving.com</p>
                <p className="text-muted" data-id="element-234">admissions@birdsnestliving.com</p>
              </div>
              <div className="space-y-4" data-id="element-235">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-236">
                  <MapPin size={24} data-id="element-237" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-238">Office</h4>
                <p className="text-muted" data-id="element-239">
                  Serving all of Maryland with regional offices in Baltimore and
                  Silver Spring.
                </p>
              </div>
              <div className="space-y-4" data-id="element-240">
                <div className="w-12 h-12 bg-primary/5 rounded-xl flex items-center justify-center text-primary" data-id="element-241">
                  <Clock size={24} data-id="element-242" />
                </div>
                <h4 className="text-xl font-bold text-charcoal" data-id="element-243">Hours</h4>
                <p className="text-muted" data-id="element-244">Mon - Fri: 9am - 5pm</p>
                <p className="text-muted" data-id="element-245">Sat - Sun: By Appointment</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white p-12 lg:p-16 rounded-3xl shadow-2xl border border-gray-100" data-id="element-246">
            <form className="space-y-6" data-id="element-247">
              <div className="space-y-2" data-id="element-248">
                <label className="text-sm font-bold text-charcoal" data-id="element-249">
                  Full Name
                </label>
                <input type="text" className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="Your Name" data-id="element-250" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-251">
                <div className="space-y-2" data-id="element-252">
                  <label className="text-sm font-bold text-charcoal" data-id="element-253">
                    Email
                  </label>
                  <input type="email" className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="email@example.com" data-id="element-254" />
                </div>
                <div className="space-y-2" data-id="element-255">
                  <label className="text-sm font-bold text-charcoal" data-id="element-256">
                    Phone
                  </label>
                  <input type="tel" className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="(410) 000-0000" data-id="element-257" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-258">
                <label className="text-sm font-bold text-charcoal" data-id="element-259">
                  Subject
                </label>
                <select className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary appearance-none" data-id="element-260">
                  <option data-id="element-261">General Inquiry</option>
                  <option data-id="element-262">Schedule a Tour</option>
                  <option data-id="element-263">Bed Availability</option>
                  <option data-id="element-264">Referral Partnership</option>
                </select>
              </div>
              <div className="space-y-2" data-id="element-265">
                <label className="text-sm font-bold text-charcoal" data-id="element-266">
                  Message
                </label>
                <textarea rows={6} className="w-full px-4 py-3 bg-gray-50 border-none rounded-xl focus:ring-2 focus:ring-primary" placeholder="How can we help you?" data-id="element-267"></textarea>
              </div>
              <Button className="w-full py-4 text-lg flex items-center justify-center space-x-2" data-id="element-268">
                <span data-id="element-269">Send Message</span>
                <Send size={18} data-id="element-270" />
              </Button>
            </form>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="py-20 px-6" data-id="element-271">
        <div className="max-w-7xl mx-auto h-[500px] rounded-3xl overflow-hidden shadow-xl border border-gray-100" data-id="element-272">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d197866.92944941655!2d-76.77491048867188!3d39.28482849999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c803aed6f483b7%3A0x44896a84223e758!2sBaltimore%2C%20MD!5e0!3m2!1sen!2sus!4v1715634000000!5m2!1sen!2sus" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" data-id="element-273"></iframe>
        </div>
      </section>
    </div>;
}